import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import './index.css'
import App from './App'
import PwaInstallPrompt from './components/pwa/PwaInstallPrompt'
import { AuthProvider } from './context/AuthContext'
import { EmpresaProvider } from './context/EmpresaContext'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <EmpresaProvider>
          <App />
        </EmpresaProvider>
      </AuthProvider>

      {/* Fuera de los providers de sesión: el CTA de instalación debe
          poder mostrarse incluso antes de iniciar sesión (p. ej. en
          Login). */}
      <PwaInstallPrompt />
    </BrowserRouter>
  </React.StrictMode>
)

serviceWorkerRegistration.register()